<script setup>
import { useGlobalStore } from '@/stores/global';
import FormApplicationPopup from '@/components/forms/FormApplicationPopup';
const globalStore = useGlobalStore();
const applicationPopup = computed(() => globalStore.applicationPopup);
</script>
<template>
  <Dialog
    v-model:visible="applicationPopup.visible"
    modal
    :header="applicationPopup?.type ? $t(`application_popup.${applicationPopup.type}_title`) : ''"
    class="application__popup"
  >
    <template #closeicon>
      <CIcon name="close-black" width="16" height="16" />
    </template>
    <FormApplicationPopup
      :type="applicationPopup.type"
      :maintenance-data="applicationPopup.maintenanceData"
    />
  </Dialog>
</template>

<style scoped lang="scss"></style>
